<script>
    import VTextField from 'vuetify/es5/components/VTextField/VTextField'

    let passwordRules = [
        v => v && v.length > 7 || 'Potreben je vnos gesla. Geslo mora biti dolgo vsaj 8 znakov.',
    ]

    export default VTextField.extend({
        name: 'PasswordField',
        extends: VTextField,
        props: {
            outline: { type: Boolean, default: true},
            rules: {
                default: function (){
                    return passwordRules;
                }
            },
            "validate-on-blur":{
                default: true
            },
            "prepend-inner-icon": {
                default: 'fa-key'
            }
        },
        data: () => {
            return {
                show_password: false
            }
        },
        computed:{
            appendIcon(){
                if (!this.$listeners['click:append']) {
                    this.$listeners['click:append'] = {};
                }
                if (this.show_password){
                    return 'visibility';
                }
                return 'visibility_off';
            },
            type(){
                if (this.show_password){
                    return 'text';
                }
                return 'password';
            }
        },
        beforeMount(){
            this.$on('click:append', function(){
                this.toggleVisibility();
            });
        },
        methods: {
            toggleVisibility(){
                this.show_password = !this.show_password;
            }
        }
    });

</script>
